import React from "react";
import ServicesPage from "../views/pages/ServicesPage";
import ServicesLayout from "../views/layouts/ServicesLayout";
import { Page404 } from "@duosoftbg/nacid-components";
import { heRecognitionRoutes } from "./heRecognitionRoutes";
import { seRecognitionRoutes } from "./seRecognitionRoutes";
import { seVerLetterRoutes } from "./seVerLetterRoutes";
import { seOfficialNoteRoutes } from "./seOfficialNoteRoutes";
import { rudiAdditionalDocRoutes } from "./rudiAdditionalDocRoutes";
import { regprofAdditionalDocRoutes } from "./regprofAdditionalDocRoutes";
import { libservAdditionalDocRoutes } from "./libservAdditionalDocRoutes";
import { seAdditionalDocRoutes } from "./seAdditionalDocRoutes";
import { docDegreesRoutes } from "./docDegreesRoutes";
import { regprofRoutes } from "./regprofRoutes";
import { uniChecksRoutes } from "./uniChecksRoutes";
import { docDeliveryRoutes } from "./docDeliveryRoutes";
import { biblioReferenceRoutes } from "./biblioReferenceRoutes";
import { officialNotesRoutes } from "./officialNotesRoutes";
import { inquiryRoutes } from "./inquiryRoutes";
import { signalRoutes } from "./signalRoutes";
import { suggestionRoutes } from "./suggestionRoutes";
import { myApplicationsRoutes } from "./myApplicationsRoutes";
import { appCheckupRoutes } from "./appCheckupRoutes";
import { publicAccessRoutes } from "./publicAccessRoutes";
import { myCorrespondenceRoutes } from "./myCorrespondenceRoutes";
import { signatureSpecificRoutes } from "./signatureSpecificRoutes";

const routes = [
  {
    path: "/",
    element: <ServicesLayout />,
    children: [
      { index: true, element: <ServicesPage /> },
      ...officialNotesRoutes,
      ...inquiryRoutes,
      ...biblioReferenceRoutes,
      ...docDeliveryRoutes,
      ...heRecognitionRoutes,
      ...seRecognitionRoutes,
      ...seVerLetterRoutes,
      ...seOfficialNoteRoutes,
      ...rudiAdditionalDocRoutes,
      ...regprofAdditionalDocRoutes,
      ...libservAdditionalDocRoutes,
      ...seAdditionalDocRoutes,
      ...docDegreesRoutes,
      ...regprofRoutes,
      ...uniChecksRoutes,
      ...suggestionRoutes,
      ...signalRoutes,
      ...publicAccessRoutes,
      ...myApplicationsRoutes,
      ...appCheckupRoutes,
      ...myCorrespondenceRoutes,
      ...signatureSpecificRoutes,
    ],
  },
  {
    path: "*",
    element: <ServicesLayout />,
    children: [
      {
        path: "*",
        element: <Page404 />,
      },
    ],
  },
];

export default routes;
